import { plastic } from './plastic'
import { miyuki } from './miyuki'
import { toho } from './toho'

export const allData = plastic.concat(miyuki).concat(toho);